






























































































































































































































import Component, { mixins } from 'vue-class-component';
import { Prop, PropSync } from 'vue-property-decorator';
import { Gender } from '@/common/constants';
import UseBackend from '@/core/mixins/use-backend';
import PersonalData = Orders.PersonalData;

@Component({
  name: 'PersonalData',
})
export default class PersonalDataComponent extends mixins(UseBackend) {
  @PropSync('data', { required: true, type: Object })
  innerData!: PersonalData;

  @Prop({ required: true, type: Boolean })
  loading!: boolean;

  Gender = Gender;
}
